import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BaseComponent } from '../../../../models/base/base-component';
import { BehaviorSubject, Observable } from 'rxjs';
import { LoadingOptions } from '../../../../models/shared/loading-options';
import { map } from 'rxjs/operators';
import { UserDomainModel } from '../../../../domainModels/user-domain-model';
import { Router } from '@angular/router';
import { DashboardViewModel } from './dashboard-view-model';
import {
  apisGloballyScopedToLoginContext,
  domainModelsGloballyScopedToLoginContext,
  repositoriesGloballyScopedToLoginContext,
  servicesGloballyScopedToLoginContext,
  viewModelsGloballyScopedToLoginContext
} from '../../../../di/logged-in-scope';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TypeService } from '../../../../services/type-service';
import { CompanyDomainModel } from '../../../../domainModels/company-domain-model';
import { exists } from '../../../../functions/exists';
import { FileSystemService } from '../../../../services/file-system.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  providers: [
    ...apisGloballyScopedToLoginContext,
    ...repositoriesGloballyScopedToLoginContext,
    ...domainModelsGloballyScopedToLoginContext,
    ...viewModelsGloballyScopedToLoginContext,
    ...servicesGloballyScopedToLoginContext,
    DashboardViewModel
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class DashboardComponent extends BaseComponent {
  constructor(
    private ngbModal: NgbModal,
    public router: Router,
    private typeService: TypeService, // initialize type service on login - don't remove
    private userDomainModel: UserDomainModel,
    private companyDomainModel: CompanyDomainModel, // initialize company domain model on login - don't remove
    private fileSystemService: FileSystemService,
    public viewModel: DashboardViewModel
  ) {
    super();
  }

  public _loadingOpts = new BehaviorSubject(LoadingOptions.default(false, true));
  public loadingOpts$ = this._loadingOpts as Observable<LoadingOptions>;
  public isLoading$ = this.loadingOpts$.pipe(map(opts => opts.isLoading));

  public readonly sidebarVisible$ = this.userDomainModel.user$.pipe(
    map(user => {
      return exists(user) ? user?.accountConfirmed || user?.session?.validSession() : false;
    })
  );

  override async setupViews() {
    this.setupLoadingOpts();
    await this.fileSystemService.setupTabLeadership();
  }

  setupLoadingOpts() {
    this.loadingOpts$.once(opts => {
      opts.zIndex = 100;
      this._loadingOpts.next(opts);
    });
  }

  /**
   * Dismiss all open models when logged in context dies.
   */
  override destroy() {
    super.destroy();
    this.ngbModal.hasOpenModals() && this.ngbModal.dismissAll();
  }
}
